import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/GridLegacy';
import { useContext, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useRetrieveBentleyAccessTokenQuery } from '../../apiClients/identityClient/requests/BentleyAccessTokenApi';
import { BENTLEY_SESSION_EXPIRED, LOGIN_ROUTE, LOGIN_ERROR_ROUTE, LOGIN_ORG_ROUTE, } from '../../constants';
import { clearLoginError } from '../../store/localStorageHelpers/loginErrorHelper';
import { getCSRFState } from '../../store/sessionStorageHelpers/authStateHelpers';
import { Background } from '../background/Background';
import { LoginContext } from '../loginHandler/LoginContext';
export function RetrieveAccessToken({ authCode, forceOauthPrefix, onSuccess, }) {
    const navigate = useNavigate();
    const { data, error } = useRetrieveBentleyAccessTokenQuery({
        authCode,
        forceOauthPrefix,
    });
    useEffect(() => {
        var _a, _b;
        if (data) {
            if (onSuccess) {
                onSuccess(data);
            }
            navigate(LOGIN_ORG_ROUTE);
        }
        if (error) {
            const errorMessage = ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.error) || 'unable_to_get_access_token';
            const errorDescription = ((_b = error === null || error === void 0 ? void 0 : error.data) === null || _b === void 0 ? void 0 : _b.error_description) || '';
            navigate(`${LOGIN_ERROR_ROUTE}?error=${errorMessage}&error_description=${errorDescription}&bentley_token=true`);
        }
    }, [data, error]);
    return (_jsx(Background, { children: _jsx(Grid, { item: true, style: {
                position: 'relative',
                width: '100%',
                height: '100px',
            }, alignContent: "center", justifyContent: "center", display: "grid", children: _jsx(CircularProgress, {}) }) }));
}
export function BentleyLoginSuccess({ onSuccess }) {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { forceOauthPrefix } = useContext(LoginContext);
    const authCode = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const storedState = getCSRFState();
    const serverSide = typeof window === 'undefined';
    const inIframe = !serverSide && window.self !== window.top;
    clearLoginError();
    useEffect(() => {
        if (inIframe) {
            window.parent.postMessage({ source: 'bentley-silent-auth', code: authCode, state, error }, window.parent.origin);
        }
        else if (state !== storedState) {
            navigate(`${LOGIN_ERROR_ROUTE}?error=invalid_auth_state&bentley_token=true`);
        }
    }, []);
    useEffect(() => {
        if (error) {
            navigate(`${LOGIN_ROUTE}?error=${BENTLEY_SESSION_EXPIRED}&bentley_token=true`);
        }
        else if (!authCode) {
            navigate(`${LOGIN_ERROR_ROUTE}?error=no_auth_token&bentley_token=true`);
        }
    }, [authCode, error]);
    if (inIframe) {
        return null;
    }
    return (_jsx(_Fragment, { children: authCode && state === storedState && (_jsx(RetrieveAccessToken, { authCode: authCode, forceOauthPrefix: forceOauthPrefix, onSuccess: onSuccess })) }));
}
//# sourceMappingURL=BentleyLoginSuccess.js.map